/**
 * Load all PMW functions
 *
 * Ignore event listeners. They need to be loaded after
 * we made sure that jQuery has been loaded.
 */

require("./functions")

/**
 * Load consent management module as a chunk
 * @returns {Promise<void>}
 */
window.pmw.loadConsentModule = async () => {
	const consentModule = await import(/* webpackChunkName: "consent-management" */ "./consent/consent.mjs")
	window.pmw.consent = consentModule
	
	const apiModule = await import(/* webpackChunkName: "consent-api" */ "./consent/api.mjs")
	window.pmw = window.pmw || {}
	window.pmw.consent = window.pmw.consent || {}
	window.pmw.consent.api = apiModule
	
	return consentModule
}

window.pmw = window.pmw || {}
window.pmw.console = require("./console.mjs")

// Load cross-tab session sync module
const crossTabSync         = require("./cross-tab-sync.mjs")
window.pmw.crossTabSync    = crossTabSync

require("./ip_services")

// #if process.env.TIER === 'premium'
// if (pmw.canLoadPremiumFeatures()) {
// 	require("./functions_premium")
// }
// #endif
